export default __webpack_public_path__ + "static/media/banner-4.6d76a8a3.png";